export const CONFIG_NAME_MAX_LENGTH = 50;

export const SYSTEM_WIDE_USER_ID = 'statsbomb-shared';
